import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router} from '@angular/router';

import {EncryptdecryptService} from './auth/encryptdecrpt.service'
import { ConsoleLoggerService } from './console-logger.service';

@Component({

  selector: 'app-root',

  templateUrl: './app.component.html',

  styleUrls: ['./app.component.css']

})

export class AppComponent implements OnInit  {

  title = 'i2a-frontend';

  razorpay: boolean = false;
  razorpay1: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute,private consoleService: ConsoleLoggerService) {
    this.consoleService.disableLogsInProd()
   }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
    //  console.log("Params", params);
      sessionStorage.setItem('Razorpay_Payment', JSON.stringify(params))
      const payment = JSON.parse(sessionStorage.getItem('Razorpay_Payment') || '{}')
      //console.log("payment", Object.keys(payment).length);
      if(Object.keys(payment).length == 0){
       //console.log("login");
        this.razorpay = true;
        this.razorpay1 = false;
      }
      else{
      //console.log("Mobile_Component");
        this.razorpay = false;
        this.razorpay1 = true;

      }
    }
    );


  }


}
